export default {
  isFavouriteGame: function isFavouriteGame(favGames, gameId) {
    if (!favGames) return false;
    return favGames.some(function (game) {
      return game.game_id === "".concat(gameId);
    });
  }
};